/** Convert a Blob to a base64 data URL */
export function blobToDataUrl(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      if (reader.result === null) {
        reject(new Error('Failed to read blob: result is null'));
      } else {
        resolve(reader.result as string);
      }
    };
    reader.readAsDataURL(blob);
  });
}